(function(global){
  'use strict';
  const URL_DB='https://gpdyhhaeenuwkpeapwra.supabase.co';
  const KEY='sb_publishable_0XxD91duJOG54fXUFyJtag_1CZN0jGL';
  const read=k=>{try{return JSON.parse(sessionStorage.getItem(k));}catch{return null;}};
  const write=(k,v)=>{try{sessionStorage.setItem(k,JSON.stringify(v));}catch{}};
  const remove=k=>{try{sessionStorage.removeItem(k);}catch{}};
  const uuid=()=>global.crypto?.randomUUID?global.crypto.randomUUID():'10000000-1000-4000-8000-100000000000'.replace(/[018]/g,c=>(c^crypto.getRandomValues(new Uint8Array(1))[0]&15>>c/4).toString(16));
  const ATTR_KEYS=['utm_source','utm_medium','utm_campaign','utm_content','utm_term','fbclid'];
  const AD_EVENTS={skin_rescue_start:'experience_started',skin_rescue_progress:'experience_progressed',skin_rescue_completed:'experience_completed',skin_rescue_result_calm:'recommendation_viewed',skin_rescue_result_hydration:'recommendation_viewed',skin_rescue_result_mixed:'recommendation_viewed',skin_rescue_single_step_selected:'product_selected',skin_rescue_full_routine_selected:'product_selected',skin_rescue_product_click:'product_clicked'};
  function create(config){
    let saved=read('hidracce.experience.session.v2');
    if(!saved||Date.now()-saved.created>86400000||Date.now()<saved.created||typeof saved.id!=='string')saved={id:uuid(),created:Date.now()};
    write('hidracce.experience.session.v2',saved);
    const sessionId=saved.id;
    let attribution=read('hidracce.experience.attribution.v2')||{};
    if(Date.now()-(attribution.created||0)>86400000)attribution={};
    const params=new URLSearchParams(location.search);
    ATTR_KEYS.forEach(key=>{if(params.get(key))attribution[key]=params.get(key).slice(0,250);});
    attribution.created=Date.now();write('hidracce.experience.attribution.v2',attribution);
    const campaign=()=>Object.fromEntries(ATTR_KEYS.filter(k=>attribution[k]).map(k=>[k,attribution[k]]));
    let optional=read('hidracce.experience.measurement.v2')===true;
    let destroyed=false;
    function adsAllowed(){
      const p=global.Shopify?.customerPrivacy;
      return optional&&(!p||(p.analyticsProcessingAllowed?.()===true&&p.marketingAllowed?.()===true));
    }
    function track(event,payload={}){
      if(destroyed)return Promise.resolve(false);
      const safeEvent=AD_EVENTS[event];
      if(config.advertising===true&&safeEvent&&adsAllowed()){
        // A fixed allowlist is the entire outbound advertising contract: never spread payload here.
        global.dataLayer=global.dataLayer||[];global.dataLayer.push({event:safeEvent});
      }
      if(config.preview===true)return Promise.resolve(true);
      const controller=new AbortController(),timer=setTimeout(()=>controller.abort(),3500);
      return fetch(URL_DB+'/rest/v1/skin_rescue_events',{
        method:'POST',headers:{apikey:KEY,'Content-Type':'application/json',Prefer:'return=minimal'},
        body:JSON.stringify({session_id:sessionId,event_name:event,payload:{...payload,attribution:campaign(),event_id:uuid(),version:'2.1.0'}}),
        signal:controller.signal,keepalive:true,credentials:'omit',referrerPolicy:'no-referrer'
      }).then(r=>r.ok).catch(()=>false).finally(()=>clearTimeout(timer));
    }
    const productUrl=value=>{try{const u=new URL(value,location.origin);if(u.protocol!=='https:'||!['hidracce.com.br','www.hidracce.com.br','hidracce.myshopify.com',location.hostname].includes(u.hostname))return '';ATTR_KEYS.filter(k=>k!=='fbclid'&&attribution[k]).forEach(k=>u.searchParams.set(k,attribution[k]));return u.href;}catch{return '';}};
    function clear(){destroyed=true;['hidracce.experience.session.v2','hidracce.experience.attribution.v2','hidracce.experience.measurement.v2','hidracce.experience.answers.v2','hidracce.reportana.converted.v1'].forEach(remove);}
    return {track,sessionId,productUrl,clear,consent:()=>optional,setConsent:value=>{optional=value;write('hidracce.experience.measurement.v2',value);},read,write,remove};
  }
  function reportana(onConvert){
    const origin='https://app.reportana.com',uuid='e42dfccf-03af-4bc2-b11e-6ff2654f7d8e',popupId=118,key='hidracce.reportana.converted.v1';
    let loading=null,acceptedAt=0;
    try{acceptedAt=Number(sessionStorage.getItem(key)||0);}catch{}
    const complete=()=>acceptedAt>0&&Date.now()>=acceptedAt&&Date.now()-acceptedAt<86400000;
    const frame=()=>[...document.querySelectorAll('iframe.rptn-popup-frame')].find(f=>{try{const u=new URL(f.src);return u.origin===origin&&u.searchParams.get('uuid')===uuid&&u.searchParams.get('id')===String(popupId);}catch{return false;}});
    const listener=e=>{
      if(complete()||e.origin!==origin||!frame()||e.source!==frame().contentWindow||e.data?.popupId!==popupId||e.data?.type!=='rptn-popup-convert')return;
      acceptedAt=Date.now();try{sessionStorage.setItem(key,String(acceptedAt));}catch{}onConvert();
    };
    global.addEventListener('message',listener);
    function load(){
      if(typeof global.rptnPopupOpen==='function')return Promise.resolve();
      if(loading)return loading;
      loading=new Promise((resolve,reject)=>{
        const s=document.createElement('script');s.async=true;s.src=origin+'/popup/script.js?uuid='+uuid;
        const timer=setTimeout(()=>{s.remove();loading=null;reject(Error('O formulário demorou para abrir. Tente novamente.'));},12000);
        s.onload=()=>{clearTimeout(timer);resolve();};s.onerror=()=>{clearTimeout(timer);s.remove();loading=null;reject(Error('Não conseguimos abrir o formulário. Confira sua conexão e tente novamente.'));};document.head.append(s);
      });return loading;
    }
    async function open(){
      await load();
      let f=frame();
      if(!f){const popup=global.rptnPopups?.find(p=>p.id===popupId);if(!popup||global.rptnPopupUuid!==uuid||typeof global.rptnPopupOpen!=='function'){loading=null;throw Error('O cadastro está indisponível agora. Tente novamente em instantes.');}global.rptnPopupOpen(popup);f=frame();}
      if(!f)throw Error('Não conseguimos abrir o cadastro. Tente novamente.');
      f.title='Cadastro Hidracce para ver seu resultado';f.focus();
    }
    return {open,complete,destroy:()=>global.removeEventListener('message',listener)};
  }
  global.HidracceExperienceServices={create,reportana};
})(window);
